"use strict";

var CardConfig = require('./card/cardConfig');
var StoredCardConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/card/storedCardConfig');
var BcmcConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/bcmc/bcmcConfig');
var BoletoConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/boleto/boletoConfig');
var GooglePayConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/googlePay/googlePayConfig');
var KlarnaConfig = require('./klarna/klarnaConfig');
var CashAppConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/cashapp/cashappConfig');
var UpiConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/upi/upiConfig');
var ApplePayConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/applePay/applePayConfig');
var AmazonPayConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/amazonPay/amazonPayConfig');
var PayPalConfig = require('./paypal/paypalConfig');
var GiftCardsConfig = require('./giftcards/giftcardsConfig');
var PayPalFastlaneConfig = require('adyen/adyen/checkout/paymentMethodsConfiguration/paypal/paypalFastlaneConfig');
var store = require('../../../../../../../../app_adyen_SFRA/cartridge/config/store');
var helpers = require('../helpers');
var _require = require('adyen/adyen/commons/httpClient'),
  httpClient = _require.httpClient;
function getPaymentMethodsConfiguration(email, amount, AdyenPaymentMethods) {
  var cardConfig = new CardConfig(store, helpers, email, amount).getConfig();
  var storedCardConfig = new StoredCardConfig(store, helpers).getConfig();
  var bcmcConfig = new BcmcConfig(store, helpers).getConfig();
  var boletoConfig = new BoletoConfig().getConfig();
  var googlePayConfig = new GooglePayConfig(helpers).getConfig();
  var klarnaConfig = new KlarnaConfig(helpers, window.klarnaWidgetEnabled).getConfig();
  var cashAppConfig = new CashAppConfig(helpers).getConfig();
  var upiConfig = new UpiConfig(helpers).getConfig();
  var applePayConfig = new ApplePayConfig(helpers, amount).getConfig();
  var payPalConfig = new PayPalConfig(store, helpers).getConfig();
  var amazonPayConfig = new AmazonPayConfig(store, helpers, AdyenPaymentMethods).getConfig();
  var giftCardsConfig = new GiftCardsConfig(store, httpClient, helpers).getConfig();
  var payPalFastlaneConfig = new PayPalFastlaneConfig(store, helpers).getConfig();
  return {
    scheme: cardConfig,
    bcmc: bcmcConfig,
    storedCard: storedCardConfig,
    boletobancario: boletoConfig,
    paywithgoogle: googlePayConfig,
    googlepay: googlePayConfig,
    paypal: payPalConfig,
    amazonpay: amazonPayConfig,
    giftcard: giftCardsConfig,
    applepay: applePayConfig,
    klarna: klarnaConfig,
    klarna_account: klarnaConfig,
    klarna_paynow: klarnaConfig,
    cashapp: cashAppConfig,
    upi: upiConfig,
    fastlane: payPalFastlaneConfig
  };
}
module.exports = getPaymentMethodsConfiguration;